export default __webpack_public_path__ + "static/media/plus-icon.7095d7c9.svg";